import React, { useEffect, useState } from "react";
import { CustomStep } from "../../../components/common/custom_steps";
import { Stepper } from "@progress/kendo-react-layout";
import { useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "@progress/kendo-react-indicators";
import {
  REWARDS_OPERATORS_LIST,
  REWARDS_OPERATORS_ADD
} from "../../../routes";
import {
  checkPermission,
  getUserPermission,
} from "../../../config/permission_helper";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import { ShowDialog } from "../../../components/reusableItems/dialog";
import { fetchOperatorDetails, fetchRewardsOperatorAudit } from "../../../store/rewardsOperator";

export const RewardsOperatorDetails = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const id = query.get("id");
  const { detail_loading, detail_data, audit_data,audit_loading } = useSelector(
    (state) => state.rewardsOperator
  );
  const userPermissions = getUserPermission();
  const viewPermssion = checkPermission(
    userPermissions,
    "gamifications.view_campaign_operator_list"
  );
  const EditPermission = checkPermission(userPermissions,"gamifications.create_campaign_operator");
  useEffect(()=>{
    dispatch(fetchOperatorDetails(id));
    dispatch(fetchRewardsOperatorAudit(id));
  },[])
  const EditAction = ()=>{
    navigate(REWARDS_OPERATORS_ADD+"?id="+id);
  }
  console.log(audit_data);
  return (
    <>
      {viewPermssion ? (
        <>
          {detail_loading || audit_loading ? (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100% - 75px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          ) : (
            <div className="Rewards_detail_main_box">
              <div className="Rewards_detail_child_box">
                <div className="Rewards_detail_left_box">
                  <div
                    className="Rewards_detail_back"
                    onClick={() => navigate(REWARDS_OPERATORS_LIST)}
                  >
                    <span class="k-icon k-font-icon k-i-arrow-chevron-left" />
                    Back
                  </div>
                  <div className="Rewards_detail_child_box_main_detail_box">
                    <div className="Rewards_detail_child_box_main_detail_items">
                      <div className="Rewards_detail_child_box_main_detail_items_title Rewards_detail_center_item detail_padding_bottom">
                        Rewards Provider
                      </div>
                      <div className="Rewards_detail_child_box_main_detail_items_splitter" />
                      <div className="Rewards_detail_center_item Rewards_detail_child_box_main_detail_items_subdetail detail_padding_bottom">
                          {detail_data?.provider_name}
                      </div>
                    </div>
                    <div className="Rewards_detail_child_box_main_detail_items">
                      <div className="Rewards_detail_child_box_main_detail_items_title Rewards_detail_center_item detail_padding_bottom">
                        Location
                      </div>
                      <div className="Rewards_detail_child_box_main_detail_items_splitter" />
                      <div className="Rewards_detail_center_item Rewards_detail_child_box_main_detail_items_subdetail detail_padding_bottom">
                          {detail_data?.name}
                      </div>
                    </div>  
                    <div className="Rewards_detail_child_box_main_detail_items">
                      <div className="Rewards_detail_child_box_main_detail_items_title Rewards_detail_center_item detail_padding_bottom">
                        Location Address
                      </div>
                      <div className="Rewards_detail_child_box_main_detail_items_splitter" />
                      <div className="Rewards_detail_center_item Rewards_detail_child_box_main_detail_items_subdetail detail_padding_bottom">
                          {detail_data?.address}
                      </div>
                    </div>
                    <div className="Rewards_detail_child_box_main_detail_items">
                      <div className="Rewards_detail_child_box_main_detail_items_title Rewards_detail_center_item detail_padding_bottom">
                        Operator Name
                      </div>
                      <div className="Rewards_detail_child_box_main_detail_items_splitter" />
                      <div className="Rewards_detail_center_item Rewards_detail_child_box_main_detail_items_subdetail detail_padding_bottom">
                          {detail_data?.officer_name}
                      </div>
                    </div>
                    <div className="Rewards_detail_child_box_main_detail_items">
                      <div className="Rewards_detail_child_box_main_detail_items_title Rewards_detail_center_item detail_padding_bottom">
                        Operator Email Address
                      </div>
                      <div className="Rewards_detail_child_box_main_detail_items_splitter" />
                      <div className="Rewards_detail_center_item Rewards_detail_child_box_main_detail_items_subdetail detail_padding_bottom">
                          {detail_data?.email}
                      </div>
                    </div>
                    <div className="Rewards_detail_child_box_main_detail_items">
                      <div className="Rewards_detail_child_box_main_detail_items_title Rewards_detail_center_item detail_padding_bottom">
                        Contact Number
                      </div>
                      <div className="Rewards_detail_child_box_main_detail_items_splitter" />
                      <div className="Rewards_detail_center_item Rewards_detail_child_box_main_detail_items_subdetail detail_padding_bottom">
                          {detail_data?.contact_no}
                      </div>
                    </div>
                    <div className="Rewards_detail_child_box_main_detail_items">
                      <div className="Rewards_detail_child_box_main_detail_items_title Rewards_detail_center_item detail_padding_bottom">
                        Officer Name
                      </div>
                      <div className="Rewards_detail_child_box_main_detail_items_splitter" />
                      <div className="Rewards_detail_center_item Rewards_detail_child_box_main_detail_items_subdetail detail_padding_bottom">
                          {detail_data?.poc_name || '-'}
                      </div>
                    </div>                                                                              
                  </div>
                </div>
                <div className="Rewards_detail_right_box">
                  <div className="Rewards_detail_right_box_action_main_box">
                    <div className="Rewards_detail_right_box_action_title">
                      Actions
                    </div>
                    {EditPermission && (
                      <div
                        className="Rewards_detail_right_box_action_edit"
                        onClick={EditAction}
                      >
                        Edit &#x2192;
                      </div>
                    )}                    
                  </div>                  
                  <div className="Rewards_detail_right_box_action_main_box">
                    <div className="Rewards_detail_right_box_action_title">
                      Activity Trail
                    </div>
                    <div className={audit_data.length <= 1 && "audit_bar_hide"}>
                      {audit_loading ? (
                        <Loader
                          type="converging-spinner"
                          style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#ffffff4d",
                          }}
                        />
                      ) : (
                        <Stepper
                          orientation={"vertical"}
                          items={audit_data}
                          item={CustomStep}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
